<template>
  <v-list-item :disabled="collection.items.length === 0" @click="addToCart">
    <v-list-item-title>
      {{ $t('collection.addToCart') }}
    </v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import useCollection from '@/modules/collection/useCollection'
import CollectionEvent from '@/modules/tracking/events/collection'
import { trackEvent } from '@/modules/tracking/useTracking'
import { DetailedShopCollection } from '@/types/index'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'CollectionAddToCartButton',
  props: {
    collection: {
      type: Object as PropType<DetailedShopCollection>,
      required: true
    }
  },
  setup(props) {
    const addToCart = () => {
      useCollection().addCollectionToCart(props.collection.id)
      trackEvent(CollectionEvent.BuyCollection)
    }

    return { addToCart }
  }
})
</script>
